export default __webpack_public_path__ + "static/media/man7.ad502039.JPG";